var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimesheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-timesheet",
    d: "M10.5,6A5.506,5.506,0,0,0,5,11.5v25A5.506,5.506,0,0,0,10.5,42H24.057a12.921,12.921,0,0,1-1.422-3H10.5A2.5,2.5,0,0,1,8,36.5V16H40v7a13.011,13.011,0,0,1,3,1.77V11.5A5.506,5.506,0,0,0,37.5,6Zm3,14a1.5,1.5,0,1,0,0,3h2a1.5,1.5,0,1,0,0-3Zm8,0a1.5,1.5,0,0,0,0,3H30a12.95,12.95,0,0,1,5-1c.3,0,.6.025.895.045A1.494,1.494,0,0,0,34.5,20ZM35,24A11,11,0,1,0,46,35,11,11,0,0,0,35,24ZM13.5,26a1.5,1.5,0,1,0,0,3h2a1.5,1.5,0,1,0,0-3Zm8,0a1.5,1.5,0,0,0,0,3h1.975a13.019,13.019,0,0,1,2.158-3ZM34,28a1,1,0,0,1,1,1v6h5a1,1,0,0,1,0,2H34a1,1,0,0,1-1-1V29A1,1,0,0,1,34,28ZM13.5,32a1.5,1.5,0,1,0,0,3h2a1.5,1.5,0,1,0,0-3Zm8,0a1.5,1.5,0,0,0,0,3H22a13.015,13.015,0,0,1,.361-3Z",
    transform: "translate(-5 -6)",
    fill: "#ea5876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimesheet);
export default __webpack_public_path__ + "static/media/iconTimesheet.f9cb6a729387da8d50cf51e5ff99dff2.svg";
export { ForwardRef as ReactComponent };